module.exports = __webpack_public_path__ + "static/19.3-11cb3a02adcd87016877ed54de7be8f4.jpg";